module.exports = __webpack_public_path__ + "static/media/product-design-second@3x.d244e9fd.jpg";